import { vuexHandbook } from '@/store/composition/handbook'
import { FoldApi } from '@/api/handbook/position/Fold/FoldApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: FoldApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
